<template>
    <v-container fluid>
        <v-row>
            <v-col cols="12">
                <v-btn color="primary" @click="addClick">
                    <v-icon small>fa-plus</v-icon>&nbsp;&nbsp;{{ $t('buttons.add') }}
                </v-btn>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12">
                <v-card flat outlined>
                    <v-card-text>
                        <v-row>
                            <v-col>
                                <TheTable
                                    :additional-filters="banksTable.additionalFilters"
                                    :default-sort="banksTable.defaultSort"
                                    :excel="true"
                                    :fields="banksTable.headers"
                                    :header-selection-key="'banks-headers'"
                                    :filter-save-key="'banks-filters'"
                                    :height="banksTable.height"
                                    :total-records="banksTable.total"
                                    @excel="excelExport"
                                    @headers="selectHeaders"
                                    @reload="reloadData"
                                >
                                    <tr
                                        v-for="(item, key) in banksTable.items"
                                        :key="key"
                                        :class="{'cursor-pointer': true}"
                                        @contextmenu.prevent="editClick(props.item.id, true)"
                                    >
                                        <td
                                            v-if="banksTable.selectedHeaders.includes('id')"
                                            style="text-align: right"
                                            class="font-weight-bold"
                                            @click="editClick(item.id, false)"
                                        >
                                            {{ item.id }}
                                        </td>
                                        <td
                                            v-if="banksTable.selectedHeaders.includes('name')"
                                            class="font-weight-bold"
                                            @click="editClick(item.id, false)"
                                        >
                                            {{ item.name }}
                                        </td>
                                        <td
                                            v-if="banksTable.selectedHeaders.includes('address')"
                                            @click="editClick(item.id, false)"
                                        >
                                            {{ item.address }}
                                        </td>
                                        <td
                                            v-if="banksTable.selectedHeaders.includes('city')"
                                            @click="editClick(item.id, false)"
                                        >
                                            {{ item.city }}
                                        </td>
                                        <td
                                            v-if="banksTable.selectedHeaders.includes('post_code')"
                                            @click="editClick(item.id, false)"
                                        >
                                            {{ item.post_code }}
                                        </td>
                                        <td
                                            v-if="banksTable.selectedHeaders.includes('country_id')"
                                            @click="editClick(item.id, false)"
                                        >
                                            {{ item.country_display }}
                                        </td>
                                        <td
                                            v-if="banksTable.selectedHeaders.includes('swift_code')"
                                            @click="editClick(item.id, false)"
                                        >
                                            {{ item.swift_code }}
                                        </td>
                                        <td
                                            v-if="banksTable.selectedHeaders.includes('active')"
                                            @click="editClick(item.id, false)"
                                        >
                                            <v-icon v-if="item.active" small>fa-check</v-icon>
                                        </td>
                                        <td>
                                            <v-tooltip bottom>
                                                <template v-slot:activator="{on, attrs}">
                                                    <v-btn
                                                        icon
                                                        v-bind="attrs"
                                                        @click="editClick(item.id, true)"
                                                        v-on="on"
                                                    >
                                                        <v-icon small>fa-external-link-alt</v-icon>
                                                    </v-btn>
                                                </template>
                                                <span>{{ $t('tooltips.openInNewTab') }}</span>
                                            </v-tooltip>
                                        </td>
                                    </tr>
                                </TheTable>
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import TheTable from './trinkets/TheTable';

export default {
    name: 'Banks',
    components: {TheTable},
    data: function () {
        return {
            banksTable: {
                selectedHeaders: [],
                headers: [
                    {
                        text: this.$t('fields.id'),
                        value: 'id',
                        type: 'string',
                        width: '75px',
                        allowFilter: true,
                    },
                    {text: this.$t('fields.name'), value: 'name', type: 'string', allowFilter: true},
                    {text: this.$t('fields.address'), value: 'address', type: 'string', allowFilter: true},
                    {text: this.$t('fields.city'), value: 'city', type: 'string', allowFilter: true},
                    {text: this.$t('fields.postalCode'), value: 'post_code', type: 'string', allowFilter: true},
                    {
                        text: this.$t('fields.country'),
                        value: 'country_id',
                        type: 'dropdown|countries',
                        allowFilter: true,
                    },
                    {text: this.$t('fields.swiftCode'), value: 'swift_code', type: 'string', allowFilter: true},
                    {
                        text: this.$t('fields.active'),
                        value: 'active',
                        type: 'boolean',
                        default: null,
                        width: '150px',
                        allowFilter: true,
                    },
                    {text: '', value: 'actions', type: '', sortable: false, width: '100px', allowFilter: false},
                ],
                additionalFilters: [],
                items: [],
                total: 0,
                lastRequest: null,
                height: '0px',
                defaultSort: {
                    field: 'name',
                    descending: true,
                },
            },
        };
    },
    methods: {
        addClick() {
            this.$router.push('/banks/0');
        },
        editClick(id, newTab = false) {
            if (!newTab) {
                this.$router.push('/banks/' + id);
            } else {
                let routeData = this.$router.resolve('/banks/' + id);
                window.open(routeData.href, '_blank');
            }
        },
        selectHeaders(headers) {
            this.banksTable.selectedHeaders = headers;
        },
        reloadData(request) {
            this.lastRequest = request;
            let vm = this;
            this.$APICall('get', 'banks', request, (data, success) => {
                if (success) {
                    vm.banksTable.items = data.items;
                    vm.banksTable.total = data.total;
                } else {
                    vm.$alert(vm.$t('alerts.basicError'));
                }
            });
        },
        excelExport() {
            let excelRequest = JSON.parse(JSON.stringify(this.lastRequest));
            excelRequest.pagination.itemsPerPage = 999999999;
            excelRequest.pagination.page = 1;

            let vm = this;
            this.$APICall(
                'get',
                'banks',
                excelRequest,
                (data, success) => {
                    if (success) {
                        vm.$APICall('post', 'excel/banks', data.items, (data) => {
                            window.open(data.link);
                        });
                    } else {
                        vm.$alert(vm.$t('alerts.basicError'));
                    }
                },
                false,
            );
        },
        resolveWindowResize() {
            this.banksTable.height = window.innerHeight - 280 + 'px';
        },
    },
    mounted() {
        if (!this.$myStore.state.loggedIn) {
            this.$router.replace('login');
        }
        this.$myStore.commit('setBreadcrumbs', [{text: this.$t('modules.banks'), href: '/#/banks', disabled: true}]);

        window.addEventListener('resize', this.resolveWindowResize);
        this.resolveWindowResize();
    },
};
</script>

<style scoped></style>
